import $ from 'jquery';
import { initHeroParticles } from '@js/parts/hero-particles';
import { initSiteHeader } from '@js/parts/header';
import { initPortfolioSlider } from '@js/parts/portfolio-slider';
import { initCasosCarousels } from '@js/parts/casos-carousel';
import { initCasosInteressos } from '@js/parts/casos-interessos';
import { initThemeToggle } from '@js/parts/theme';

$(function(){
  initThemeToggle();
  initHeroParticles();
  initSiteHeader();
  initPortfolioSlider();
  initCasosInteressos();
  initCasosCarousels();
});
